module.exports = __webpack_public_path__ + "static/search-bg-fa421bc132b4c8329f4d0ad4d16b3136.jpg";